import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateOutboxDto } from './create-outbox.dto';

/**
 * Update outbox DTO
 */
export class UpdateOutboxDto extends CreateOutboxDto {
	@TransformInt()
	id!: number;
}
